import { render, staticRenderFns } from "./CorporateTransactionHistoryComponent.vue?vue&type=template&id=30eb8c4e&"
import script from "./CorporateTransactionHistoryComponent.vue?vue&type=script&lang=js&"
export * from "./CorporateTransactionHistoryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports